import { TopPickTile } from '~/contracts/dealership';
import cdjrTopPicks from './cdjr/topPicks';
import DealershipFamily from './DealershipFamily';

const topPicksFamilyMap: Record<string, TopPickTile[]> = {
  [DealershipFamily.Cdjr]: cdjrTopPicks
};

export default topPicksFamilyMap;
